<template>
  <order-list :is-order-status="15"></order-list>
</template>

<script>
import OrderList from './components/OrderList'
export default {
  name: 'Picking',
  components: {
    OrderList
  }
}
</script>
